export enum DateFormatEnum {
  DATETIME_FORMAT = 'DD.MM.YYYY HH:mm',
  DATETIME_FORMAT_WITH_SEC = 'DD.MM.YYYY HH:mm:ss',
  DATETIME_DB_FORMAT = 'DD.MM.YYYY HH24:MI',
  UTC_DATETIME_FORMAT = 'YYYY-MM-DD"T"HH24:MI:SS.MS"Z"',
  DATE_FORMAT = 'DD.MM.YYYY',
  /** Weekday + date (moment), e.g. "вт, 08.09.2026" */
  WEEKDAY_DATE_FORMAT = 'dd, DD.MM.YYYY',
  /** Weekday + long date (moment, ru), e.g. "чт, 05 сентября 2024" — classic project deadline */
  WEEKDAY_LONG_DATE_FORMAT = 'ddd, DD MMMM YYYY',
  /** Weekday + long date + time (moment, ru), e.g. "чт, 05 сентября 2024 09:00" */
  WEEKDAY_LONG_DATETIME_FORMAT = 'ddd, DD MMMM YYYY HH:mm',
  UTC_YEAR_WEEK_FORMAT = 'YYYY-WW',
  UTC_DATE_YY_FORMAT = 'YYYY-MM-DD',
  UTC_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss',
  UTC_DATETIME_FORMAT_WITHOUT_MS = 'YYYY-MM-DD"T"HH:mm:ss',
  YEAR_MONTH_DAY_FORMAT = 'YYYY.MM.DD',
  YEAR_WEEKS_FORMAT = 'YYYYWW',
  YEAR_MONTH_FORMAT = 'YYYY-MM',
  YEAR_MONTHS_FORMAT = 'YYYYMM',
  YEAR_FORMAT = 'YYYY',
  YEAR_WEEK_FORMAT = 'YYYYW',
  YEAR_WEEK_LOCALIZED_FORMAT = 'Wo YYYY',
  YEAR_MONTH_LOCALIZED_FORMAT = 'MMM YYYY',
  /** Day + full month name + year (moment, ru), e.g. "05 сентября 2024" */
  MONTH_DAY_LONG_YEAR_FORMAT = 'DD MMMM YYYY',
  /** Full month name + year (moment), e.g. "Сентябрь 2026" */
  MONTH_YEAR_LONG_FORMAT = 'MMMM YYYY',
  /** Month + year (moment), e.g. "09.2026" */
  MONTH_YEAR_SHORT_FORMAT = 'MM.YYYY',
  YEAR_QUARTER_FORMAT = 'YYYY-Q',
  YEAR_QUARTER_LOCALIZED_FORMAT = 'Qo YYYY',
  UTC_DATE_YY_FORMAT_REVERSED = 'DD-MM-YYYY',
  PAYMENT_DATE_FORMAT = 'YYYYMMDD',
}
